<div class="custom-mat-dialog">
  <div mat-dialog-title class="mat-dialog-header-with-close-btn">
    <h4 class="xl:text-2xl lg:text-xl text-lg text-black font-medium"> {{ data?.itemInfo?.description ||
    'Media'}}</h4>
    <button mat-icon-button aria-label="Close" class="close-icon" (click)="closeModal()">
      <mat-icon svgIcon="c:x"></mat-icon>
    </button>
  </div>

  <mat-dialog-content>
    <!-- Content Section -->
    <div class="flex flex-wrap xl:-mx-4 md:-mx-2 xl:-my-3 -my-2">
      @for (media of data?.media || []; track media; let i = $index) {
        <div class="2xl:w-1/6 xl:w-1/6 lg:w-1/6 md:w-1/6 sm:w-1/6 w-full p-2">
          <div class="common-image-card-with-image-name p-2">
            <div class="w-100 relative">
              @if (!isImageLoaded(media)) {
                <div class="img-loading-skeleton"></div>
              }
              <img class="card-image" [src]="getFileUrl(media)" (click)="onFileTileClick(media, i)"
                [title]="isImageFile(media) ? '' : media.caption"
                role="button" tabindex="0" (keydown.enter)="onFileTileClick(media, i)"
                alt="Media" (load)="markImageAsLoaded(media)"
                (error)="setDefaultImage($event)" />
                <div class="actions absolute flex items-center justify-center gap-2 top-2 right-2">
                  <div (click)="downloadFile(media)" title="Download"
                    role="button" tabindex="0" (keydown.enter)="downloadFile(media)"
                    class="bg-white h-[22px] w-[22px] flex items-center justify-center rounded-[4px] cursor-pointer">
                    <img src="../../../../../assets/icons/download.svg" width="13" alt="">
                  </div>
                  @if (!data?.isDisabled && isImageFile(media)) {
                    <div (click)="openPinturaEditImageModal(media)" title="Edit"
                      role="button" tabindex="0" (keydown.enter)="openPinturaEditImageModal(media)"
                      class="bg-white h-7 w-7 flex items-center justify-center rounded-[4px] cursor-pointer">
                      <img src="../../../../../assets/icons/edit.svg" alt="">
                    </div>
                  }
                  @if (!data?.isDisabled) {
                    <div (click)="openDeleteImageModal(i)" title="Delete"
                      role="button" tabindex="0" (keydown.enter)="openDeleteImageModal(i)"
                      class="bg-red h-7 w-7 flex items-center justify-center rounded-[4px] cursor-pointer">
                      <img src="../../../../../assets/icons/delete.svg" alt="">
                    </div>
                  }
                </div>
              </div>
              <!-- <h4 class="text-black text-[12px] leading-5 whitespace-pre-wrap break-words text-wrap">
              {{ getImageNameByImageUrl(image) }}
            </h4> -->
          </div>
        </div>
      }
    </div>
  </mat-dialog-content>
</div>